import { IRegion } from '../models/region.model';
import { IPaginationData, IPaginationQuery, request } from './base';

function getAll() {
  return request<IRegion[]>({
    url: '/region',
    params: {
      lang: 'en',
    },
    method: 'GET',
  });
}

function listing(
  query: IPaginationQuery & {
    order?: 'ASC' | 'DESC';
    sort_by?: string;
    keyword?: string;
  },
) {
  return request<IPaginationData<IRegion>>({
    url: '/region/listing',
    params: query,
    method: 'GET',
  });
}

function getDetail(id: string) {
  return request<IRegion>({
    url: `/region/${id}`,
    method: 'GET',
  });
}

function create(data: Partial<IRegion>) {
  return request<IRegion>({
    url: `/region`,
    method: 'POST',
    data,
  });
}

function update(id: string, data: Partial<IRegion>) {
  return request<IRegion>({
    url: `/region/${id}`,
    method: 'PATCH',
    data,
  });
}

function remove(id: string) {
  return request<IRegion>({
    url: `/region/${id}`,
    method: 'DELETE',
  });
}

const categoryApi = Object.freeze({
  getAll,
  listing,
  create,
  getDetail,
  remove,
  update,
});

export default categoryApi;
